/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabInventoryType from './diag-lab-inventory-type';
import DiagLabInventoryTypeDetail from './diag-lab-inventory-type-detail';
import DiagLabInventoryTypeUpdate from './diag-lab-inventory-type-update';
import DiagLabInventoryTypeDeleteDialog from './diag-lab-inventory-type-delete-dialog';

const DiagLabInventoryTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabInventoryType />} />
    <Route path="new" element={<DiagLabInventoryTypeUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabInventoryTypeDetail />} />
      <Route path="edit" element={<DiagLabInventoryTypeUpdate />} />
      <Route path="delete" element={<DiagLabInventoryTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabInventoryTypeRoutes;
